import React from 'react'
import { Grid } from '@material-ui/core'
import { AuthConsumer } from '../../context/AuthContext'
import UserMenu from '../UserMenu'
import { useStyles } from './Styles'
import Logo from '../Logo'
import { LanguageConsumer } from '../../context/LanguageContext'
import LanguageSwitcher from '../LanguageSwitcher'
import HeaderNotification from '../HeaderNotification'
//import HeaderMenu from '../HeaderMenu'

const DesktopView = () => {
  const classes = useStyles()

  return (
    <Grid item className={classes.headerDesktop}>
      <Logo/>
      <div className={classes.userMenuWrapper}>
        <div className={classes.headerLinksWrapper}>
          {/*<HeaderMenu/>*/}
          <HeaderNotification/>
          <LanguageSwitcher/>
        </div>
        <AuthConsumer>
          {({ taxpayerData, userData, userPermissions }) => (
            <LanguageConsumer>
              {({ locale }) => (
                <>
                  <UserMenu userData={userData} taxpayerData={taxpayerData} userPermissions={userPermissions} locale={locale}/>
                </>
              )}
            </LanguageConsumer>
          )}
        </AuthConsumer>
      </div>
    </Grid>
  )
}

export default DesktopView
